import history from '../history';

export default class ProductsService {
  checkBundleOrder(friendlyName, coupon) {
    if (friendlyName !== 'bundle') {
      return false;
    }

    if (coupon) {
      this.addBundleProductsToCart(coupon);
    }
    return true;
  }

  addBundleProductsToCart(coupon) {
    let ids = coupon.productIds;
    if (ids !== null) {
      for (let id = 0; id < ids.length; id++) {
        this.getProductConfig(ids[id], id, ids);
      }
    }
  }

  getProductConfig(value, index, array) {
    let details = {
      industry: null,
      packageName: null,
      quoteServiceType: null,
      id: value
    };
    switch (value) {
      case 1:
        details.industry = 'investors';
        details.packageName = 'basic';
        details.quoteServiceType = 'RPPRealEstate';
        this.addProductPackageToCart(details, 'rp-data-professional', index, array);
        break;
      case 8:
        details.packageName = 'investors_premium';
        details.quoteServiceType = 'ReportBundle';
        this.addProductPackageToCart(details, 'investors-premium', index, array);
        break;
      case 4:
        details.packageName = 'premier';
        details.quoteServiceType = 'Blockbrief';
        this.addProductPackageToCart(details, 'blockbrief', index, array);
        break;
      default:
        break;
    }
  }

  productSwitch(value) {
    let cartItem = null;
    switch (value.quoteServiceType) {
      case 'RPPRealEstate':
        cartItem = this.rppProduct(value);
        break;
      case 'ReportBundle':
        cartItem = this.reportBundleProduct(value);
        break;
      case 'Blockbrief':
        cartItem = this.blockbriefProduct(value);
        break;
      default:
        break;
    }

    return cartItem;
  }

  addProductPackageToCart(value, friendlyName, index, array) {
    let cartItem = null;
    this.props.fetchProduct(friendlyName).then(
      function () {
        this.props.setPackage(value.industry, value.packageName, friendlyName);

        cartItem = this.productSwitch(value);

        if (
          this.props.order &&
          this.props.order !== null &&
          Object.keys(this.props.order).length > 0
        ) {
          this.props.deleteOrder('').then(
            function () {
              this.props.saveCartItem(cartItem, 'bundle');
            }.bind(this)
          );
        } else {
          this.props.saveCartItem(cartItem, 'bundle').then(() => {
            if (index === array.length - 1) {
              history.push(`/product_config/${array[0]}`);
              // this.props.fetchQuote(this.productSwitch(array[0]),array[0])
              // setTimeout(()=>{
              this.props.fetchCart().then(
                function () {
                  this.props.applyCoupon(this.props.couponCode);
                }.bind(this)
              );
              // }, 1000)
            }
          });
        }
      }.bind(this)
    );
  }

  rppProduct(value) {
    let cartItem = {
      configuration: {
        addons: [],
        geography: {
          national: false,
          states: []
        },
        industry: value.industry,
        number_of_users: 1,
        package: value.packageName,
        product_id: value.id
      },
      product_id: value.id
    };
    return cartItem;
  }

  reportBundleProduct(value, friendlyName) {
    let cartItem = {
      configuration: {
        packageName: value.packageName,
        geography: {
          states: null
        },
        product_id: value.id
      },
      product_id: value.id
    };

    return cartItem;
  }

  blockbriefProduct(value, friendlyName) {
    let cartItem = {
      configuration: {
        package: value.packageName,
        number_of_users: 1,
        product_id: value.id
      },
      product_id: value.id
    };

    return cartItem;
  }

  checkProductConfigWizard() {
    let productIds = this.getIncompleteProductIds();
    return productIds.length > 1 ? true : false;
  }

  isGeoValidationRequired(packageKey) {
    if (
      packageKey !== 'property_developers_and_construction' &&
      packageKey !== 'residential' &&
      packageKey !== 'trial'
    ) {
      return true;
    }
    return false;
  }

  getIncompleteProductIds() {
    let productIds = [];
    if (this.props.cart && this.props.cart.cartItems && this.props.cart.cartItems.length > 0) {
      let cartItems = this.props.cart.cartItems;
      for (let itemIndex = 0; itemIndex < cartItems.length; itemIndex++) {
        let config = JSON.parse(cartItems[itemIndex].configuration);
        let incomplete = null;
        if (config.configuration && this.isGeoValidationRequired(config.configuration.package)) {
          let configBlob = config.configuration;
          if (
            configBlob.package !== undefined &&
            (configBlob.package === null || configBlob.package === '')
          ) {
            incomplete = true;
          } else if (
            configBlob.packageName !== undefined &&
            (configBlob.packageName !== null || configBlob.packageName !== '')
          ) {
            incomplete = false;
          } else if (
            configBlob.number_of_users !== undefined &&
            (configBlob.number_of_users === null || configBlob.number_of_users < 1)
          ) {
            incomplete = true;
          } else if (
            configBlob.geography !== undefined &&
            (configBlob.geography.states === null || configBlob.geography.states.length === 0)
          ) {
            incomplete = true;
            if (
              configBlob.geography.national !== undefined &&
              configBlob.geography.national === true
            ) {
              incomplete = false;
            }
          } else {
            incomplete = false;
          }
        }

        if (incomplete) {
          productIds.push(config.configuration.product_id);
        }
      }
    }
    return productIds;
  }
}
